var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "20px",
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "palm-tree") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Managers",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Iconen-drukke-dagen",
    transform: "translate(-24.000000, -46.000000)",
    fill: "#FF8100",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "palm-tree",
    transform: "translate(24.000000, 46.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,7 C10.59,14.61 7,20 7,20 L10,20 C11.88,14.2 11,10.09 10.5,8 M12.66,5.16 C12.83,5.37 13,5.59 13.13,5.82 C14.84,8.53 14.5,11.95 12.5,14.26 C13.34,12.21 13.22,9.79 11.95,7.77 C11.87,7.64 11.78,7.53 11.7,7.41 C11.11,6.58 10.36,5.92 9.54,5.43 C6.66,6.35 4.58,9.04 4.58,12.22 C4.58,12.96 4.69,13.67 4.89,14.33 C4.05,13.16 3.56,11.73 3.56,10.19 C3.56,7.84 4.7,5.76 6.45,4.46 C5,4.35 3.46,4.67 2.12,5.5 C1.5,5.91 0.96,6.38 0.5,6.91 C1.05,5.58 2,4.39 3.3,3.57 C4.8,2.63 6.5,2.32 8.14,2.56 C7.73,2 7.23,1.47 6.63,1 C6.05,0.58 5.42,0.24 4.76,0 C6.2,0.04 7.64,0.5 8.87,1.43 C9.5,1.9 10,2.47 10.4,3.07 C10.5,3.07 10.59,3.06 10.69,3.06 C13.89,3.06 16.6,5.17 17.5,8.08 C16.38,6.5 14.65,5.43 12.66,5.16 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalm);
export default __webpack_public_path__ + "static/media/palm.027f1a60e8f82c16f372fd553f7769c9.svg";
export { ForwardRef as ReactComponent };